if (window.hmInitSearchAutocomplete) {
    window.hmInitSearchAutocomplete();
}
